import { useEffect } from "react";
import { Heading, Paragraph } from "@vwfs-bronson/bronson-react";
import { CommonProductPage } from "@product-pages/components/common";
import { useTranslation } from "react-i18next";

export interface ErrorBasePageProps {
  onClick?: Function;
}

const ErrorBasePage = () => {
  const { t } = useTranslation();
  const texts = t("error:errorOption:texts", { returnObjects: true }) as Array<string>;

  useEffect(() => {
  }, []);

  return (
    <CommonProductPage>
      <Heading level={1} className="u-mb-large">
        {t("error:errorOption:title")}
      </Heading>
      {texts.map((text: string) => (
        <Paragraph>{text}</Paragraph>
      ))}
    </CommonProductPage>
  );
};
export default ErrorBasePage
